/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { abbreviateThousands, numberWithCommas } from 'helper';
import withDashboard from '../../common/hoc/withDashboard';
import * as c from '../constants';
import * as actions from '../actions';

const CollectionsGraph2 = ({
  getCollections,
  collections, // per month
  createDynamicAreaChartVersion2,
  isLoading,
  getYearList,
  yearList,
  className,
}) => {
  const initForm = {
    year: moment(new Date()).format('YYYY'),
  };

  var index = yearList.map(function (x) { return +x.year; }).indexOf(+initForm.year);

  const [filterData, setFilterData] = useState(initForm);
  const [isButtonClick, setIsButtonClicked] = useState(false);


  useEffect(() => {
    getYearList()
    getCollections({ year: filterData.year })
  }, []);

  const GroupCollectionByYear = _.groupBy(collections, 'year')

  let collectionPerYear = []

  collectionPerYear = _.map(GroupCollectionByYear, (value, year) => {
    return {
      year,
      sum: _.reduce(value, (total, item) => total + item.collection, 0)
    }
  })

  const handleOnFilterYear = (value) => (e) => {
    e.preventDefault()
    setFilterData({
      ...filterData,
      year: value,
    })
    setIsButtonClicked(true);
    getCollections({ year: value })
  }

  const formatNumberWithCommas = value => {
    return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const displayAreaChart = createDynamicAreaChartVersion2(
    collections,
    [{ key: filterData.year, color: '#5272AA' }],
    {
      xAxisProps: {
        fontSize: '10px',
        // angle: -35,
        scale: 'point',
      },
      yAxisProps: {
        // angle: -55,
      },
      composeOption: {
        bottom: 20,
      },
    },
    isLoading
  )

  return (
    <div className={`collections row col-md-12 item-box-shadow ${className}`}>
      <div className="collections-header ">Collections</div>
      <div className="collections-body d-flex">
        <div className="year-container">
          <ul>
            {isButtonClick === false && (
              yearList.map((item, i) => (
                <li key={item.year}>
                  <button
                    className={`btn btn-link btn-col-year rounded ${index === i ? 'btn-active' : ''}`}
                    type="button"
                    onClick={handleOnFilterYear(item.year)}
                  >
                    {item.year}
                  </button>
                </li>
              ))
            )}
            {isButtonClick === true && (
              yearList.map(item => (
                <li key={item.year}>
                  <button
                    className={`btn btn-link btn-col-year rounded ${item.year === filterData.year ? 'btn-active' : ''}`}
                    type="button"
                    onClick={handleOnFilterYear(item.year)}
                  >
                    {item.year}
                  </button>
                </li>
              ))
            )}
          </ul>
        </div>
        <div className="area-body">
          <div className="year-headers">
            {/* <div className="yh-numbers"> */}
            <ul
              className="d-flex justify-content-around flex-row"
              style={{ listStyleType: 'none', width: '100%', fontSize: '12px' }}
            >
              {
                collectionPerYear.map(collection => {
                  return (
                    <li key={collection.year}>
                      <div className="d-flex justify-content-center flex-column mx-2">
                        <div
                          style={{ textAlign: 'center' }}
                          className="yh-year w-100"
                        >
                          {collection.year}
                        </div>
                        <div className="d-flex justify-content-around align-items-center">
                          <span
                            style={{ fontSize: '16px' }}
                            className="yh-total per-year-total"
                          >
                            {formatNumberWithCommas(collection.sum)}
                          </span>
                          <span
                            style={{ color: '#ffffff' }}
                            className="yh-meter pos per-year-percentage"
                          >
                            100% <i className="fas fa-angle-up" />
                          </span>
                        </div>
                      </div>
                    </li>
                  )
                })
              }
            </ul>
            {/* </div> */}
          </div>
          <div className="my-3 legends" style={{ fontSize: '13px' }}>
            <span>Legend:</span>
            <span className="legend inc rounded px-1 mx-1">
              Increase <i className="fas fa-angle-up" />
            </span>
            <span className="legend decr rounded px-1 mx-1">
              Decrease <i className="fas fa-angle-down" />
            </span>
            <span className="legend star rounded px-1 mx-1">
              Current <i className="fas fa-star" />
            </span>
          </div>
          {displayAreaChart}
        </div>
      </div>
    </div>
  );
};

CollectionsGraph2.defaultProps = {
  collections: [],
  className: '',
};

CollectionsGraph2.propTypes = {
  createDynamicAreaChart: PropTypes.instanceOf(Function).isRequired,
  createDynamicAreaChartVersion2: PropTypes.instanceOf(Function).isRequired,
  getCollections: PropTypes.instanceOf(Function).isRequired,
  collections: PropTypes.instanceOf(Array),
  isLoading: PropTypes.bool.isRequired,
  getYearList: PropTypes.instanceOf(Function).isRequired,
  yearList: PropTypes.instanceOf(Array).isRequired,
  className: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  collections: formatCollections(_.get(api, `${c.GET_COLLECTION}.res`)),
  yearList: _.get(api, `${c.GET_YEAR_LIST}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_COLLECTION) > -1,
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

const formatCollections = (data) => {
  const newArr = [];
  if (_.get(data, 'data')) {
    _.get(data, 'data').map((val, idx) => {
      data[idx] = {
        ...val,
        name: moment.months(parseInt(val.name) - 1),
      };
      newArr.push(data[idx]);
    });
    return newArr;
  }
  return data;
};

export default enhance(CollectionsGraph2);
